import { useEffect, VFC } from "react";
// Libraries
import { useHistory } from "react-router-dom";
// Utils
import { CREATE_LISTING, TRADING } from "constants/Routes";
import { useEventRequest, useGetAnimalCount } from "hooks";
// Containers
import { BuyerListings } from "trading/components/containers";
// Components
import { ListingFiltersServerSide, ListingSortServerSide } from "trading/components";
import { Flex, PageContent, Spacer, Title } from "components";

export const ViewBuyerListings: VFC = () => {
  const history = useHistory();
  const { eventsRequest } = useEventRequest();
  const { data } = useGetAnimalCount();

  useEffect(() => {
    eventsRequest({ name: "view-buying-liveweight" });
  }, [eventsRequest]);

  return (
    <PageContent
      floatingIconTextButton={{
        iconName: "plus",
        onClick: (): void => {
          eventsRequest({ name: "listing-started-buying" });
          history.push(`${TRADING}${CREATE_LISTING}`);
        },
        disabled: data === 0,
        text: "Create Listing",
      }}
    >
      <Spacer baselineHeight={3} />

      <Flex container containerAlignItems="flex-start">
        <Flex item itemGutter xs={3}>
          <Spacer allowDecimal baselineHeight={0.5} />

          <Title tertiary>Filter</Title>

          <Spacer allowDecimal baselineHeight={1.5} />

          <ListingFiltersServerSide instance="buyer" />
        </Flex>

        <Flex container containerDirection="column" item xs={9}>
          <Flex container containerAlignItems="center" item xs="fill">
            <Flex item itemGutter xs={6} />

            <Flex item itemGutter xs={3}>
              <ListingSortServerSide instance="buyer" />
            </Flex>
          </Flex>
          <Spacer baselineHeight={1} />
          <Flex item itemGutter xs="fill">
            <BuyerListings />
          </Flex>
        </Flex>
      </Flex>
    </PageContent>
  );
};
